import React, { useState } from "react";
import { toast } from "sonner";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Field, TextField } from "@/components/kit/fields";
import { SearchSelect } from "@/components/kit/SearchSelect";
import { TIMEZONES_WITH_AUTO } from "@/lib/timezones";
import { browserTimezone } from "@/lib/format";
import { FileUpload } from "@/components/kit/FileUpload";
import { Button } from "@/components/ui/button";

export function ProfileSettings() {
  const { user, refresh } = useAuth();
  const [form, setForm] = useState({
    name: user?.name || "", avatar: user?.avatar || "", username: user?.username || "",
    telegram: user?.telegram || "", discord: user?.discord || "",
    timezone: user?.timezone || "",
  });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    if (!form.name) return toast.error("Name is required");
    setSaving(true);
    try {
      await http.put("/auth/me", form);
      await refresh();
      toast.success("Profile updated");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to update");
    } finally { setSaving(false); }
  };

  return (
    <div className="max-w-2xl space-y-5 rounded-xl border border-white/[0.08] bg-[#141417] p-6" data-testid="profile-settings">
      <div className="flex items-center gap-4">
        <FileUpload value={form.avatar} onChange={(v) => set("avatar", v)} kind="avatar" aspect="favicon" testId="profile-avatar" />
        <div className="text-sm text-muted-foreground">Upload a profile picture.</div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <TextField label="Full name" value={form.name} onChange={(v) => set("name", v)} testId="profile-name" />
        <TextField label="Username" value={form.username} onChange={(v) => set("username", v)} testId="profile-username" />
        <TextField label="Email" value={user?.email || ""} onChange={() => {}} testId="profile-email" />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <TextField label="Telegram" value={form.telegram} onChange={(v) => set("telegram", v)} testId="profile-telegram" placeholder="@handle" />
        <TextField label="Discord" value={form.discord} onChange={(v) => set("discord", v)} testId="profile-discord" />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <Field label="Timezone" hint={`Auto-detected from your device: ${browserTimezone() || "Europe/Kyiv"}. Pick a timezone to override it — your choice always wins.`}>
          <SearchSelect
            value={form.timezone}
            onChange={(v) => set("timezone", v)}
            options={TIMEZONES_WITH_AUTO}
            placeholder="Auto — device timezone"
            searchPlaceholder="Search timezone…"
            testId="profile-timezone"
            widthClass="w-[320px]"
            triggerClass="h-10"
          />
        </Field>
        <TextField label="Language" value="English" onChange={() => {}} testId="profile-language" />
      </div>
      <Button onClick={save} disabled={saving} data-testid="profile-save" className="bg-white text-black hover:bg-white/90">Save changes</Button>
    </div>
  );
}
